webpackJsonp([35783957827783],{

/***/ 67:
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(2),__webpack_require__(7),__webpack_require__(68)):"function"==typeof define&&define.amd?define(["react","prop-types","react-dom"],t):"object"==typeof exports?exports["react-parallax"]=t(require("react"),require("prop-types"),require("react-dom")):e["react-parallax"]=t(e.React,e.PropTypes,e.ReactDOM)}(this,function(e,t,n){return function(e){function t(i){if(n[i])return n[i].exports;var r=n[i]={i:i,l:!1,exports:{}};return e[i].call(r.exports,r,r.exports,t),r.l=!0,r.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,i){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:i})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=4)}([function(t,n){t.exports=e},function(e,n){e.exports=t},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),l=n(1),u=i(l),c=n(0),d=i(c),g=function(e){function t(){return r(this,t),a(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return o(t,e),s(t,[{key:"render",value:function(){return d.default.createElement("div",{className:"react-parallax-background "+this.props.className},this.props.children)}}],[{key:"isParallaxBackground",value:function(){return!0}}]),t}(d.default.Component);g.propTypes={children:u.default.node,className:u.default.string},g.defaultProps={className:""},t.default=g},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),l=n(1),u=i(l),c=n(0),d=i(c),g=n(6),f=i(g),p=n(5),h=function(e){function t(e){r(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.onWindowResize=function(){n.parentHeight=(0,p.getNodeHeight)(n.canUseDOM,n.parent),n.updatePosition()},n.onWindowLoad=function(){n.updatePosition()},n.onScroll=function(e){if(n.canUseDOM){var t=Date.now();t-n.timestamp>=10&&(0,p.isScrolledIntoView)(n.node,100,n.canUseDOM)&&(window.requestAnimationFrame(n.updatePosition),n.timestamp=t)}},n.updatePosition=function(){var e=!1;if(n.content=n.ReactDOM.findDOMNode(n.refs.content),n.contentHeight=n.content.getBoundingClientRect().height,n.contentWidth=n.node.getBoundingClientRect().width,n.content){n.img&&n.img.naturalWidth/n.img.naturalHeight<n.contentWidth/n.getImageHeight()&&(e=!0);var t=(0,p.getRelativePosition)(n.node,n.canUseDOM,n.parent);n.img&&n.setImagePosition(t,e),n.bg&&n.splitChildren.bgChildren.length>0&&n.setBackgroundPosition(t)}},n.state={bgImage:e.bgImage,bgImageSrcSet:e.bgImageSrcSet,bgImageSizes:e.bgImageSizes,childStyle:{position:"relative"}},n.canUseDOM=(0,p.canUseDOM)(),n.ReactDOM=f.default.findDOMNode?f.default:d.default,n.node=null,n.content=null,n.splitChildren=(0,p.getSplitChildren)(e),n.bgImageLoaded=!1,n.bgImageRef=void 0,n.parent=e.parent,n.parentHeight=(0,p.getNodeHeight)(n.canUseDOM,n.parent),n.timestamp=Date.now(),n.dynamicBlur=!(!e.blur||void 0===e.blur.min||void 0===e.blur.max),n}return o(t,e),s(t,[{key:"componentDidMount",value:function(){var e=this.props.parent,t=this.state,n=t.bgImage,i=t.bgImageSrcSet,r=t.bgImageSizes;this.parent=e||document,this.addListeners(this.props),this.node=this.ReactDOM.findDOMNode(this),n?this.loadImage(n,i,r):this.updatePosition(),this.setParallaxStyle(),this.setInitialBackgroundStyles(this.img),this.setInitialBackgroundStyles(this.bg)}},{key:"componentWillReceiveProps",value:function(e){var t=e.parent,n=e.bgImage,i=e.bgImageSrcSet,r=e.bgImageSizes;this.splitChildren=(0,p.getSplitChildren)(e),t&&this.parent!==t&&(this.parent=t,this.removeListeners(),this.addListeners()),this.parentHeight=(0,p.getNodeHeight)(this.canUseDOM,this.parent),this.state.bgImage!==n&&this.loadImage(n,i,r)}},{key:"shouldComponentUpdate",value:function(e,t){return e.bgImage===this.props.bgImage||t.bgImage!==this.state.bgImage}},{key:"componentWillUnmount",value:function(){this.removeListeners(this.parent),this.releaseImage()}},{key:"setParallaxStyle",value:function(){this.node&&(this.node.style.position="relative",this.node.style.overflow="hidden")}},{key:"setInitialBackgroundStyles",value:function(e){var t=this;e&&(e.style.position="absolute",e.style.left="50%",e.style.WebkitTransform="translate3d(-50%, 0, 0)",e.style.transform="translate3d(-50%, 0, 0)",e.style.WebkitTransformStyle="preserve-3d",e.style.WebkitBackfaceVisibility="hidden",e.style.MozBackfaceVisibility="hidden",e.style.MsBackfaceVisibility="hidden",this.props.bgStyle&&Object.keys(this.props.bgStyle).forEach(function(n){e.style[n]=t.props.bgStyle[n]}))}},{key:"setBackgroundPosition",value:function(e){var t=this.props,n=t.disabled,i=t.strength;if(!0!==n){var r=i<0,a=(r?i:0)-i*e;this.bg.style.WebkitTransform="translate3d(-50%, "+a+"px, 0)",this.bg.style.transform="translate3d(-50%, "+a+"px, 0)"}}},{key:"setImagePosition",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=this.props,i=n.bgHeight,r=n.bgWidth,a=n.disabled,o=n.strength,s=n.blur,l=i||(t?"auto":this.getImageHeight()+"px"),u=r||(t?this.contentWidth+"px":"auto");if(this.img.style.height=l,this.img.style.width=u,!0!==a){var c=o<0,d=(c?o:0)-o*e;if(this.img.style.WebkitTransform="translate3d(-50%, "+d+"px, 0)",this.img.style.transform="translate3d(-50%, "+d+"px, 0)",s){var g=this.dynamicBlur?s.min+(1-e)*s.max:s;(0,p.setBlur)(this.img,g)}}}},{key:"getImageHeight",value:function(){var e=this.props.strength<0,t=e?2.5:1,n=t*Math.abs(this.props.strength);return Math.floor(this.contentHeight+n)}},{key:"addListeners",value:function(){this.canUseDOM&&this.parent&&(this.parent.addEventListener("scroll",this.onScroll,!1),window.addEventListener("resize",this.onWindowResize,!1),window.addEventListener("load",this.onWindowLoad,!1))}},{key:"removeListeners",value:function(){this.canUseDOM&&this.parent&&(this.parent.removeEventListener("scroll",this.onScroll,!1),window.removeEventListener("resize",this.onWindowResize,!1),window.removeEventListener("load",this.onWindowLoad,!1))}},{key:"loadImage",value:function(e,t,n){var i=this;this.releaseImage(),this.bgImageRef=new Image,this.bgImageRef.onload=function(r){i.setState({bgImage:e,bgImageSrcSet:t,bgImageSizes:n},function(){return i.updatePosition()})},this.bgImageRef.onerror=this.bgImageRef.onload,this.bgImageRef.src=e,this.bgImageRef.srcset=t||"",this.bgImageRef.sizes=n||""}},{key:"releaseImage",value:function(){this.bgImageRef&&(this.bgImageRef.onload=null,this.bgImageRef.onerror=null,delete this.bgImageRef)}},{key:"bgMounted",value:function(e){this.bg=this.ReactDOM.findDOMNode(e)}},{key:"log",value:function(){if(this.props.log){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];console.log(t)}}},{key:"render",value:function(){var e=this,t=this.props,n=t.className,i=t.style,r=t.bgClassName,a=t.bgImageAlt,o=this.state,s=o.bgImage,l=o.bgImageSrcSet,u=o.bgImageSizes,c=o.childStyle;return d.default.createElement("div",{className:"react-parallax "+n,style:i},s?d.default.createElement("img",{className:r,src:s,srcSet:l,sizes:u,ref:function(t){return e.img=t},alt:a}):null,this.splitChildren.bgChildren.length>0?d.default.createElement("div",{className:"react-parallax-background-children",ref:function(t){return e.bgMounted(t)}},this.splitChildren.bgChildren):null,d.default.createElement("div",{className:"react-parallax-content",style:c,ref:"content"},this.splitChildren.children))}}]),t}(d.default.Component);h.propTypes={bgClassName:u.default.string,bgHeight:u.default.string,bgImage:u.default.string,bgImageAlt:u.default.string,bgImageSizes:u.default.string,bgImageSrcSet:u.default.string,bgStyle:u.default.object,bgWidth:u.default.string,blur:u.default.oneOfType([u.default.number,u.default.object]),className:u.default.string,disabled:u.default.bool,log:u.default.bool,parent:u.default.any,strength:u.default.number,style:u.default.object},h.defaultProps={bgClassName:"react-parallax-bgimage",bgImageAlt:"",className:"",disabled:!1,log:!1,strength:100},t.default=h},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.Background=t.Parallax=void 0;var r=n(3),a=i(r),o=n(2),s=i(o);t.Parallax=a.default,t.Background=s.default},function(e,t,n){"use strict";function i(e){if(!e)return 0;var t=window,n=document,i=n.documentElement,r=n.getElementsByTagName("body")[0];return t.innerHeight||i.clientHeight||r.clientHeight}function r(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=arguments[2];if(!n)return!1;var r=e.getBoundingClientRect().top-t,a=e.getBoundingClientRect().bottom+t;return r<=i(n)&&a>=0}function a(e,t){return e?t?t.clientHeight:i(e):0}function o(){return!("undefined"==typeof window||!window.document||!window.document.createElement)}function s(e,t,n){return(n-e)/(t-e)||0}function l(e,t,n){if(!t)return 0;var i=e,r=Math.round(i.getBoundingClientRect().top),o=a(t);return r=r>o?o:r,s(0,o,r)}function u(e){var t=[],n=g.default.Children.toArray(e.children);return n.forEach(function(e,i){e.type&&e.type.isParallaxBackground&&(t=t.concat(n.splice(i,1)))}),{bgChildren:t,children:n}}function c(e,t){e.style.WebkitFilter="blur("+t+"px)",e.style.filter="blur("+t+"px)"}Object.defineProperty(t,"__esModule",{value:!0}),t.getWindowHeight=i,t.isScrolledIntoView=r,t.getNodeHeight=a,t.canUseDOM=o,t.getPercentage=s,t.getRelativePosition=l,t.getSplitChildren=u,t.setBlur=c;var d=n(0),g=function(e){return e&&e.__esModule?e:{default:e}}(d)},function(e,t){e.exports=n}])});

/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/arcade.67179a00.png";

/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hack.a9cad16d.png";

/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logoshadow.3ee99ae3.png";

/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/meinthesnowbnw.51d9405b.png";

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mewithglasses.c0288890.jpg";

/***/ }),

/***/ 447:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/rodrigobackgroundbnw.11ef944a.png";

/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/rodrigoblackandwhite.8f986fbd.png";

/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roult.f23590af.jpg";

/***/ }),

/***/ 297:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(297);
	
	var _reactParallax = __webpack_require__(123);
	
	var _meinthesnowbnw = __webpack_require__(445);
	
	var _meinthesnowbnw2 = _interopRequireDefault(_meinthesnowbnw);
	
	var _logoshadow = __webpack_require__(444);
	
	var _logoshadow2 = _interopRequireDefault(_logoshadow);
	
	var _roult = __webpack_require__(449);
	
	var _roult2 = _interopRequireDefault(_roult);
	
	var _hack = __webpack_require__(442);
	
	var _hack2 = _interopRequireDefault(_hack);
	
	var _arcade = __webpack_require__(440);
	
	var _arcade2 = _interopRequireDefault(_arcade);
	
	var _mewithglasses = __webpack_require__(446);
	
	var _mewithglasses2 = _interopRequireDefault(_mewithglasses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('header', null),
	    _react2.default.createElement(
	      _reactParallax.Parallax,
	      { strength: 100, bgImage: __webpack_require__(448) },
	      _react2.default.createElement(
	        'div',
	        { style: {} },
	        _react2.default.createElement(
	          'div',
	          {
	            style: {
	              alignItems: 'center',
	              justifyContent: 'center',
	              display: 'flex',
	              margin: 'auto auto',
	              maxWidth: 1300,
	              paddingTop: '9%',
	              paddingBottom: '9%',
	              paddingLeft: '5%',
	              paddingRight: '5%'
	            } },
	          _react2.default.createElement('img', { className: 'myLogo', src: _logoshadow2.default, style: { maxHeight: '530px', borderRadius: "0px", textAlign: "left" } })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'introVideo',
	        style: {
	          margin: '0px' } },
	      _react2.default.createElement(
	        'div',
	        { style: {
	            backgroundColor: '#f4f4f4',
	            paddingTop: '33px' } },
	        _react2.default.createElement(
	          'div',
	          { style: {
	              maxWidth: '960px',
	              marginLeft: 'auto',
	              marginRight: 'auto'
	            } },
	          _react2.default.createElement(
	            'h2',
	            { style: { fontSize: '50px', padding: '10px' } },
	            'Who am I?'
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: {
	
	                justifyContent: 'center',
	                display: 'flex'
	              } },
	            _react2.default.createElement(
	              'div',
	              {
	                style: { alignItems: 'center' }
	
	              },
	              _react2.default.createElement('img', { className: 'imgRodrigoSnow', src: _meinthesnowbnw2.default, style: { maxHeight: "400px", borderRadius: "5px", textAlign: "right", margin: '10px' } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'infoAboutMe' },
	              _react2.default.createElement(
	                'h3',
	                null,
	                'About Me'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'infoTextAboutMe' },
	                'I am a undergraduate student in computer science at the Tecnologico de Monterrey, with experience developing websites, iOS apps, videogames and software. I love learning new things and I am always open to learning better stuff for the future.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'infoTextAboutMe moreAboutMe', style: { textAlign: "left", maxWidth: '600px', margin: '0 auto', fontFamily: 'Ubuntu', lineHeight: '' } },
	            _react2.default.createElement(
	              'p',
	              { style: { margin: '0 30px' } },
	              'I\'ve had several experiences programming, which they have brought me more than knowledge, they have a special place in my heart. I\'ve had experiences programming in Python, C, C++, Swift and Javascript, you can take a look at my projects, which those gave me several skills, technical, analytical and social, helping me to get the job done.'
	            )
	          ),
	          _react2.default.createElement('div', { style: { height: "20px" } })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactParallax.Parallax,
	      {
	        blur: { min: -0, max: 0 },
	        bgImage: __webpack_require__(447),
	        bgImageAlt: 'rorris',
	        strength: 100,
	        bgStyle: {
	          backgroundPosition: 'center center'
	
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            margin: '0 auto',
	            maxWidth: 1300,
	            padding: '1rem 1.0875rem 1rem',
	            paddingTop: '2.5rem',
	            marginBottom: '0'
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'cobo' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'imUrFav' },
	            'PROJECTS'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: {
	          backgroundColor: '#f4f4f4',
	          paddingTop: '33px' } },
	      _react2.default.createElement(
	        'div',
	        { style: {
	            maxWidth: '1100px',
	            marginLeft: 'auto',
	            marginRight: 'auto'
	          } },
	        _react2.default.createElement(
	          'h2',
	          { style: { fontSize: '50px', padding: '10px' } },
	          'Main Projects'
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: {
	
	              justifyContent: 'center',
	              display: 'flex'
	            } },
	          _react2.default.createElement(
	            'div',
	            {
	              style: { alignItems: 'center', padding: '10px' }
	
	            },
	            _react2.default.createElement('img', { className: 'imgProject', src: _roult2.default, style: { maxHeight: "300px", borderRadius: "5px", textAlign: "right", marginBottom: '0' } })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'infoAboutProject', style: { textAlign: 'center', margin: '0 auto', maxWidth: '500px', padding: '20px', paddingTop: '10px' } },
	          _react2.default.createElement(
	            'h3',
	            { style: { fontSize: '27' } },
	            'ROULT 4403'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'infoTextAboutProject' },
	            'I joined FRC (FIRST Robotic Competition) in 2018 with the team ROULT 4403. My main area was the programming subdivision but I was highly involved in the mechatronics and chairmans subdivisions. This experience taught me more than just robotics, but it also taught me social skills as leadership and communication. I had international experience assisting to the Little Rock, Arkansas FRC regional.                '
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: {
	
	              justifyContent: 'center',
	              display: 'flex'
	            } },
	          _react2.default.createElement(
	            'div',
	            {
	              style: { alignItems: 'center', padding: '10px' }
	
	            },
	            _react2.default.createElement('img', { className: 'imgProject', src: _hack2.default, style: { maxHeight: "300px", borderRadius: "5px", textAlign: "right", marginBottom: '0' } })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'infoAboutProject', style: { textAlign: 'center', margin: '0 auto', maxWidth: '500px', padding: '20px', paddingTop: '10px' } },
	          _react2.default.createElement(
	            'h3',
	            { style: { fontSize: '27' } },
	            'HACK MTY 2018'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'infoTextAboutProject' },
	            'I participated in the Hack MTY 2018: a Hackathon in Tecnologico de Monterrey, in which I created a website with a team of developers. I always try to improve and gain as much knowledge as possible. I also enjoy these kind of events because I\u2018m always open to make new friends and creating experiences.                '
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: {
	
	              justifyContent: 'center',
	              display: 'flex'
	            } },
	          _react2.default.createElement(
	            'div',
	            {
	              style: { alignItems: 'center', padding: '10px' }
	
	            },
	            _react2.default.createElement('img', { className: 'imgProject', src: _arcade2.default, style: { maxHeight: "300px", borderRadius: "5px", textAlign: "right", marginBottom: '0' } })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'infoAboutProject', style: { textAlign: 'center', margin: '0 auto', maxWidth: '500px', padding: '20px', paddingTop: '10px' } },
	          _react2.default.createElement(
	            'h3',
	            { style: { fontSize: '27' } },
	            'ROULT: THE VIDEOGAME'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'infoTextAboutProject' },
	            'For the Laguna Regional I built an arcade machine for the people to play. I programmed the game and designed the assets based on ROULT, then I built the arcade machine from recycled materials and unused electronic parts. The game was a total success in the regional since almost wanted to try the game. Also I made a GameBoy Advance port for this game, and you can ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://mega.nz/#!NAVlWACC!BqCdjagU701xN7Waqn3_jwywwW7fK9PzoVGJ4CSnpC0', target: '_blank' },
	              'download it here.'
	            ),
	            '                '
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { margin: "0 auto", height: "50px", backgroundColor: "#262626", fontFamily: "Ubuntu", justifyContent: 'center', display: 'flex', padding: '10px', color: 'white' } },
	      'Website made by Rodrigo Casale :)'
	    )
	  );
	};
	console.log("🅡🅞🅓🅡🅘🅖🅞🅒🅐.🅢🅐🅛🅔 𝖜𝖆𝖘 𝖍𝖊𝖗𝖊 :)");
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-991f230a69a1adee4734.js